// extracted by mini-css-extract-plugin
export default {"updateProfileContainer":"UpdateProfile_updateProfileContainer__13Nbm","updateProfileForm":"UpdateProfile_updateProfileForm__OgTYf"};